import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/Treatments';

export interface ITreatment {
  entitlements: ITreatmentEntitlementDTO[];
  orders: ITreatmentOrderDTO[];
}

export interface ITreatmentEntitlementDTO {
  catalogNumber: string;
  catalogNumberDescription: string;
  beginDateEntitlement: Date;
  endDateEntitlement?: Date;
  daysBalanceStartDate: Date;
  entitlementDays: number;
  daysBalance: number;
  accompanied: string;
  displayRestrictionMessage: boolean;
}

export interface ITreatmentOrderDTO {
  orderNumberSupplier: string;
  catalogNumber: string;
  requestId: string;
  startDate?: Date;
  endDate?: Date;
  entitledYear?: number;
  daysNumber?: number;
  originalDaysNumber?: number;
  accompaniedNumber?: number;
  tokenId?: number;
  fine: number;
  fineReason?: number;
  status?: boolean;
  statusLabel?: string;
  hotelName: string;
  medicinalHotSprings: string;
  supplier: {
    id: number;
    supplierName: string;
    supplierUrl: string;
  };
}

export const getTreatments = async () => {
  const res = await api.get<ITreatment>(addImposterToUrl(baseUrl, true));
  if (res.data) {
    return res.data;
  }
};

export const getOneTimeCode = async (body: any, userId: string) => {
  const res = await api.post(
    process.env.REACT_APP_SERVER_API_URL + '/Treatments/GetOneTimeCode',
    body,
    {
      headers: {
        'user-identity': userId,
      },
    }
  );

  if (res.data) {
    return res.data;
  }
};

export const getSupplierRedirectCode = async (supplierId: number) => {
  const res = await api.get(
    addImposterToUrl(`${baseUrl}/supplier/${supplierId}`, true)
  );
  if (res.data) return res.data;
};
